




























































































import { Component, Mixins } from "vue-property-decorator";
import UserFilter from "../filters/UserFilter.vue";
import MultiProfessionListUserFilter from "../filters/MultiProfessionListUserFilter.vue";
import DepartmentListUserFilter from "../filters/DepartmentListUserFilter.vue";
import ProjectTeamMemberFilter from "../filters/ProjectTeamMemberFilter.vue";
import BelongedAllDepartmentsUserFilter from "../filters/BelongedAllDepartmentsUserFilter.vue";
import UserListSelector from "../selectors/UserListSelector.vue";
import UserDetailViewer from "../viewers/UserDetailViewer.vue";
import { UserListSelectorDialogMixin } from "./mixins";

@Component({
  components: {
    UserFilter,
    MultiProfessionListUserFilter,
    DepartmentListUserFilter,
    ProjectTeamMemberFilter,
    BelongedAllDepartmentsUserFilter,
    UserListSelector,
    UserDetailViewer,
  },
})
export default class UserListSelectorDialog extends Mixins(UserListSelectorDialogMixin) {
  async openedDialog(): Promise<void> {
    await this.$nextTick();
    if (this.isDepartmentFeatureEnable) {// 起動時に科で職員の初回絞り込みが行われる.診療科非表示時は全職員を表示し選択できるようにする
      const userFilter = this.$refs.userFilter as UserFilter;
      userFilter.focus();
      const departmentFilter = this.$refs.departmentFilter as DepartmentListUserFilter;
      departmentFilter.scrollIntoView();
      const userSelector = this.$refs.userSelector as UserListSelector;
      userSelector.scrollIntoView();      
    }
  }
}
